export default __webpack_public_path__ + "static/media/img8.a1d0fa9a.PNG";